import classNames from 'classnames';
import { toast, ToastContent, Id, ToastOptions } from 'react-toastify';

import { NotifyType, themes } from '@components/ToastContainer';

// types
type SimpleToast = (content: ToastContent, options?: ToastOptions) => Id;
type BaseThemedNotify = (notifyType: NotifyType) => SimpleToast;

// Themed notifications builder
const baseThemedNotify: BaseThemedNotify = (notifyType) => (
  (content, options) => toast(
    content,
    {
      ...options,
      className: classNames(options?.className as string, themes[notifyType]),
    },
  )
);

// Themed notifications shortcuts
export const notifySuccess = baseThemedNotify(NotifyType.Success);
export const notifyError = baseThemedNotify(NotifyType.Error);
